
import BaseFirebaseRepository from '../../../components/repository/BaseFirebaseRepository';

const instances = {}
const defaultInstanceKey = Math.random()
export default class QueueNumberPageItemRepository extends BaseFirebaseRepository {
    /**
     * @param {*} app
     * @return {QueueNumberPageItemRepository}
     */
    static getInstance(app, options = {}) {
        if (app == null) {
            // By default, use instance created from main App
            app = QueueNumberPageItemRepository.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new QueueNumberPageItemRepository(app)
            if (options.merchantId) {
                instances[app].merchantId = options.merchantId
            }
        }
        return instances[app]
    }

    static getDefaultInstance() {
        if (window.merchant_id) {
            return QueueNumberPageItemRepository.getInstance(null, {merchantId: parseInt(window.merchant_id)})
        }
        else {
            return QueueNumberPageItemRepository.getInstance()
        }
    }
    getRef = () => {
        const ref = firebase.database().ref(firebase_path + '/queue_number_page_items/')
        if (this.merchantId) {
            return ref
                .orderByChild("merchant_id")
                .equalTo(this.merchantId)
        }
        return ref
    }
    getSingleRef = () => {
        return firebase.database().ref(firebase_path + '/queue_number_page_items/')
            .orderByChild("id")
    }
    getBaseObject = () => {
        return {}
    }

    onThrottledResultByGroup = (callback, callbackKey, context, trottleTime = 200) => {
        if (!callbackKey) {
            return
        }

        // If calling this function again with existing callbackKey, cancel the previous callback timer
        if (this.onThrottledResultByGroupTimer[callbackKey]) {
            clearTimeout(this.onThrottledResultByGroupTimer[callbackKey])
        }

        this.loadAll((queueNumberPageItems) => {
            if (this.onThrottledResultByGroupTimer[callbackKey]) {
                clearTimeout(this.onThrottledResultByGroupTimer[callbackKey])
            }
            this.onThrottledResultByGroupTimer[callbackKey] = setTimeout(() => {
                let queueNumberDataMap = {}
                queueNumberPageItems.forEach(qnpItem => {
                    if (typeof queueNumberDataMap[qnpItem.table_session_id] === 'undefined') {
                        // Not added yet, add now using current value
                        queueNumberDataMap[qnpItem.table_session_id] = {
                            id                  : qnpItem.id,
                            queue_number        : qnpItem.queue_number,
                            table_session_id    : qnpItem.table_session_id,
                            is_ready            : qnpItem.is_ready,
                        }
                    }
                    else {
                        // Already added, use && operator to that if any instance if is_ready = false, then
                        // the final value will be false
                        queueNumberDataMap[qnpItem.table_session_id].is_ready = queueNumberDataMap[qnpItem.table_session_id].is_ready && qnpItem.is_ready
                    }
                })

                // Split it into 2 status group
                let preparing = []
                let ready = []
                for (let tableSessionId in queueNumberDataMap) {
                    if (queueNumberDataMap[tableSessionId].is_ready) {
                        ready.push(queueNumberDataMap[tableSessionId])
                    }
                    else {
                        preparing.push(queueNumberDataMap[tableSessionId])
                    }
                }

                // Sort the final result
                ready.sort((a, b) => a.queue_number - b.queue_number)
                preparing.sort((a, b) => a.queue_number - b.queue_number)

                callback({
                    ready, preparing, queueNumberPageItems,
                })
            }, trottleTime);
        }, callbackKey, context)
    }
}
